import { defineComponent as _defineComponent } from 'vue'
import * as routes from '@/router/route-names'
import {computed, ComputedRef, onMounted, ref, type Ref} from 'vue'
import { HttpClient } from '@/components/httpclient/http-client'
import {useStore} from '@/store/store'
import {League, ShowLeaguesResp} from '@/types/league-types'
import {AxiosResponse} from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicLandingPage',
  setup(__props) {

const store = useStore()

onMounted(async () => {
  await showLeagues()
  loading.value = false
})

const loading = ref(true)
const leagues : Ref<League[]> = ref([])

const isLoggedIn = computed(()=> store.getters.isLoggedIn)
const loggedInUser = computed(()=> store.getters.getLoggedInUser)
const getUserLeagueIds :ComputedRef<string[]> = computed(()=> store.getters.getUserLeagueIds)

const myLeagues = computed(() => {
  const myLeagues : League[] = []
  leagues.value.forEach(l => {
    if (getUserLeagueIds.value.includes(l.id)) {
      myLeagues.push(l)
    }
  })
  return myLeagues
})

const otherLeagues = computed(() => {
  const myLeagues : League[] = []
  leagues.value.forEach(l => {
    if (!getUserLeagueIds.value.includes(l.id)) {
      myLeagues.push(l)
    }
  })
  return myLeagues
})

const showLeagues = async () => {
  try {
    const response :AxiosResponse<ShowLeaguesResp> = await HttpClient.get('/oapi/leagues')
    if (response.data && response.data.leagues){
      leagues.value = response.data.leagues
    }
  } catch (ex) {
    console.error(ex)
  }
}



return { __sfc: true,store, loading, leagues, isLoggedIn, loggedInUser, getUserLeagueIds, myLeagues, otherLeagues, showLeagues, routes }
}

})